import { getFestivalCo2QuizForms } from '@/ui/pages/app/project/festival/utils/festival-co2-quiz-form-data';

import { exportToExcel } from './export-excel/export-excel';
import { preparaDataToForExcelExport } from './prepare-data-for-excel-export/preparaDataToForExcelExport';

export function exportFestivalCo2Questions() {
  const co2FormsData = getFestivalCo2QuizForms();
  const co2FormsDataForExcel = preparaDataToForExcelExport(co2FormsData);
  exportToExcel(co2FormsDataForExcel);
}
